import axios from "axios";

const BASE_URL = process.env.REACT_APP_GS1_BASE_URL;
const EMAIL_BASE_URL = process.env.REACT_APP_MAIL_URL;

export default axios.create({
	baseURL: BASE_URL,
});

export const axiosPrivate = axios.create({
	baseURL: BASE_URL,
	headers: { "Content-Type": "application/json" },
	withCredentials: true,
});

export const informerEmailInstance = axios.create({
	baseURL: EMAIL_BASE_URL,
	headers: { "Content-Type": "application/json" },
});

